import { unref, computed } from 'vue';

/**
 * Domain composable for seat release rules.
 *
 * This is a true Vue composable that accepts a teatro (ref/computed/plain)
 * and returns reactive refs that the UI can consume directly.
 *
 * API:
 *   const { usesPoints, refundTextKey } = useSeatReleaseRules(teatro)
 *
 * Behavior:
 * - If teatro.uses_points_for_refund is provided (boolean), it wins.
 * - Otherwise we fall back to a historical list of tenant hashes.
 *
 * NOTE: knownPointsTenants is intentionally private to this module. Do not
 * export implementation details — keep the composable contract small and stable.
 */

// Known tenants that use points for refunds (historical reasons)
// Initialized with Talavera's hash as a temporary fallback.
// TODO: remove this fallback when the teatros API exposes `uses_points_for_refund`.
const knownPointsTenants = new Set(['gmGXtYPCl9NFgS1Vf889']);

export function useSeatReleaseRules(teatro) {
    const teatroRef = computed(() => unref(teatro));

    const usesPoints = computed(() => {
        const t = teatroRef.value;
        if (!t) return false;
        if (typeof t.uses_points_for_refund === 'boolean') return t.uses_points_for_refund;
        return knownPointsTenants.has(t.hash);
    });

    const refundTextKey = computed(() => {
        return usesPoints.value
            ? 'perfil.asiento_liberado_remobolso_texto_puntos'
            : 'perfil.asiento_liberado_remobolso_texto';
    });

    return {
        usesPoints,
        refundTextKey
    };
}
